import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export type ViewOrigem =
  | "detalhe"
  | "portfolio_modal"
  | "portfolio_externo"
  | "linkedin"
  | "kanban_historico"
  | "falar_com_frila"
  | "comparar"
  | "projetos_modal"
  | "assistente_ia"
  | "atividade"
  | "painel_candidato";

export function trackFreelancerView(
  freelancerId: string | null | undefined,
  origem: ViewOrigem,
  metadata?: Record<string, unknown>,
): void {
  if (!freelancerId) return;
  // RPC ainda não está nos types gerados (M93). Cast para any segue o padrão usado
  // em outros pontos do projeto (ex.: FreelancersCacheContext).
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (supabase as any)
    .rpc("registrar_visualizacao_freelancer", {
      p_freelancer_id: freelancerId,
      p_origem: origem,
      p_metadata: metadata ?? {},
    })
    .then(({ error }: { error: { message: string } | null }) => {
      if (error) console.warn("[track-view] falha:", error.message);
    });
}

export function useTrackFreelancerView(
  freelancerId: string | null | undefined,
  origem: ViewOrigem,
  metadata?: Record<string, unknown>,
): void {
  useEffect(() => {
    if (freelancerId) trackFreelancerView(freelancerId, origem, metadata);
    // intencionalmente ignora metadata em deps — só re-disparar se id/origem mudar
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [freelancerId, origem]);
}
